import { api } from "../../../../utils/api";
import { toast } from "react-toastify";
import { getIndexReadjustment } from "../../../GlobalRoles/getIndexReadjustment";

export const onSubmitDeleteIndexReadjustment = async (
  resetIndex,
  setLoading,
  setVisible,
  data,
  idIndex
) => {
  try {
    var id = data;
    setLoading(true);

    await api.delete(`index-readjustment/${id}`);

    // Executar GetRegistrationType após a atualização bem-sucedida
    await getIndexReadjustment(idIndex, setLoading);

    resetIndex();
    toast.success("Índice de Reajuste Excluído com Sucesso!");
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.error
      : "Erro desconhecido ao excluir o Índice de Reajuste.";
    toast.error(
      `Não Possível Excluir Índice de Reajuste! Erro: ${errorMessage}`
    );
    resetIndex();
  } finally {
    setLoading(false);
    setVisible(false);
  }
};
